import { Moment } from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReactECharts from 'echarts-for-react';
import moment from 'moment';
import './classification-daily-insights.scss'

function ClassificationDailyInsights({
    projectId,
    dateFrom,
    dateTo,
    counts
}: {
    projectId: number,
    dateFrom: Moment,
    dateTo: Moment
    counts: number[]
}) {
    const [xAxis, setXAxis] = useState<string[]>([]);
    const brandAssocIds = ['total', 'owned', 'earned', 'chatter'];
    console.log(counts)
    const getClassification = (brandAssocId: number) => {
        switch (brandAssocId) {
            case 0:
                return {
                    name: "Total",
                    color: '#A51D44'
                }
            case 1:
                return {
                    name: "Owned",
                    color: '#639FE3'
                }
            case 2:
                return {
                    name: "Earned",
                    color: '#4BB543'
                }
            case 3:
                return {
                    name: "Chatter",
                    color: '#FF6821'
                }
        }
    }

    useEffect(() => {
        let _xAxis: string[] = [];
        const days = dateTo.diff(dateFrom, 'days');

        if (days >= 30 && days < 90) {
            for (let i = dateFrom.clone(); i.isSameOrBefore(dateTo); i.add(7, 'days')) {
                let dtFrom = i;
                let dtTo = i.clone().add(6, 'd');
                if (dtTo > moment()) {
                    dtTo = moment();
                }
                _xAxis.push(`${dtFrom.format('D MMM YYYY')} - ${dtTo.format('D MMM YYYY')}`);
                setXAxis(_xAxis);
            }
        } else if (days >= 90) {
            for (let i = dateFrom.clone(); i.isSameOrBefore(dateTo); i.add(1, 'month')) {
                let dtFrom = i;
                let dtTo = i.clone().add(1, 'M').subtract(1, 'd');
                if (dtTo > moment()) {
                    dtTo = moment();
                }
                _xAxis.push(`${dtFrom.format('D MMM YYYY')} - ${dtTo.format('D MMM YYYY')}`);
                setXAxis(_xAxis);
            }
        } else {
            for (let i = dateFrom.clone(); i.isSameOrBefore(dateTo); i.add(1, 'day')) {
                _xAxis.push(`${i.format('D MMM YYYY')}`);
                setXAxis(_xAxis);
            }
        }
    }, [dateFrom, dateTo, counts]);

    return (
        <div className="classification-daily-insights">
            <div className="top">
                <p>Daily Insights</p>
            </div>
            <div className="body">
                <ReactECharts
                    option={{
                        tooltip: {},
                        legend: {
                            data: brandAssocIds,
                            top: 10
                        },
                        grid: {
                            left: 30,
                            right: 10,
                            top: 45,
                            bottom: 20
                        },
                        xAxis: {
                            data: xAxis
                        },
                        yAxis: {
                            minInterval: 1
                        },
                        series: brandAssocIds.map((x: string, i: number) => {
                            console.log('shit', counts[i])
                            return {
                                name: brandAssocIds[i],
                                type: 'bar',
                                color: getClassification(i)?.color,
                                data: [counts[i]]
                            }
                        })
                    }}
                    notMerge={true}
                    onEvents={{
                        //'click': onClick
                    }}
                />
            </div>
        </div>
    )
}

export default ClassificationDailyInsights;